export default __webpack_public_path__ + "static/media/13.cd6c2b4b.jpeg";